import { useCallback, useEffect, useState } from 'react'
import { authService } from '../services/authService'
import {
  getNextRepeatUrl,
  RepeatScreen,
  RepeatScreens,
} from '../utils/repeatFlow'

const isPFAEUser = (): boolean => {
  try {
    const userData = localStorage.getItem('user_data')
    return userData ? JSON.parse(userData).personType === 'PFAE' : false
  } catch {
    return false
  }
}

// Detecta si la solicitud activa es 2da+ (recorrido abreviado) y expone
// getNextUrl(pantallaActual) según consultasStatus.screens.
export function useRepeatFlow() {
  const [isRepeat, setIsRepeat] = useState(false)
  const [screens, setScreens] = useState<RepeatScreens | null>(null)

  useEffect(() => {
    authService
      .getRepeatFlowInfo()
      .then(info => {
        setIsRepeat(info.isRepeat)
        setScreens(info.screens)
      })
      .catch(() => setIsRepeat(false))
  }, [])

  const getNextUrl = useCallback(
    (current: RepeatScreen) => getNextRepeatUrl(current, isPFAEUser(), screens),
    [screens]
  )

  // Igual que getNextUrl, pero vuelve a pedir consultasStatus.screens: se usa
  // al terminar una pantalla (ya con sus datos guardados) porque lo capturado
  // puede cambiar qué pantallas siguientes aplican. Si el fetch falla o no
  // trae screens se conservan los del montaje.
  const resolveNextUrl = useCallback(
    async (current: RepeatScreen): Promise<string> => {
      let effective = screens
      try {
        const info = await authService.getRepeatFlowInfo()
        if (info.screens) {
          effective = info.screens
          setScreens(info.screens)
        }
      } catch {
        // Se usan los screens del montaje.
      }
      return getNextRepeatUrl(current, isPFAEUser(), effective)
    },
    [screens]
  )

  return { isRepeat, getNextUrl, resolveNextUrl }
}
